module.exports = {
  assetPrefix: `/terms`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://crunchyroll.com`,
    url: `https://crunchyroll.com/terms`,
    title: `Terms & Conditions`,
    description: `Details of the terms and conditions of Crunchyroll offerings.`,
    banner: {
      url: `https://crunchyroll.com/terms/default-banner.jpg`,
      width: `1080`,
      height: `565`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`, `webp`],
          quality: 80,
        },
      },
    },
    `gatsby-plugin-image`,
  ],
}
